/** Nombre corto y natural del sector para frases personalizadas. */
export const getSectorNoun = (
  sector: string | null | undefined,
  lang: "es" | "en",
): string => {
  const key = sector?.toLowerCase().trim() ?? "";

  if (lang === "es") {
    const nouns: Record<string, string> = {
      ropa: "tienda", zapateria: "tienda", moda: "tienda",
      restaurante: "restaurante", restauracion: "restaurante", bar: "bar",
      cafeteria: "cafetería", cafeterias: "cafetería", panaderia: "panadería",
      peluqueria: "peluquería", estetica: "centro de estética", farmacia: "farmacia",
      parafarmacia: "parafarmacia", supermercado: "supermercado",
      alimentacion: "tienda de alimentación", muebles: "tienda de muebles",
      hogar: "tienda de muebles", joyeria: "joyería", inmobiliaria: "inmobiliaria",
    };
    return nouns[key] ?? "negocio";
  }

  const nouns: Record<string, string> = {
    ropa: "shop", zapateria: "shop", moda: "shop", restaurante: "restaurant",
    restauracion: "restaurant", bar: "bar", cafeteria: "café", cafeterias: "café",
    panaderia: "bakery", peluqueria: "hair salon", estetica: "beauty salon",
    farmacia: "pharmacy", parafarmacia: "health and beauty store",
    supermercado: "grocery store", alimentacion: "grocery store",
    muebles: "furniture store", hogar: "furniture store", joyeria: "jewelry store",
    inmobiliaria: "real estate agency",
  };
  return nouns[key] ?? "business";
};